<div class="data-object">
    <div class="data-object-item left">
        <div class="tem-field" [formGroup]="group">
            <label class="tem-field-label" [attr.for]="config.IDCOLUMN">{{configRef.COLUMNDESC}}<span class="tem-field-required" *ngIf="config.ISIDENTITY != 1 && config.ISREQUIRED == 1"> *</span></label>
            <nz-input-group [nzSuffix]="suffixTpl">
                <input nz-input [tabindex]="tabindex" [formControlName]="config.headerName!=null?config.headerName:config.COLUMNNAME.split('->')[0]" [id]="config.IDCOLUMN" [required]="config.ISIDENTITY ==1? false : config.ISREQUIRED == 1" #inp (input)="editing()" (blur)="onFocus($event); bluring($event)">
            </nz-input-group>
            <ng-template #suffixTpl>
                <span class="tem-field-suffix">
                    <button tabindex="-1" *ngIf="config.ISPK != 1 && showBuscaDados" nz-button nzType="text" nzSize="small" aria-label="Buscar do Dados" (click)="dynamicServices.getDataFromTable(group, config.COLUMNNAME,entityName,null, null, 'text' );editing();onFocus($event)" nz-tooltip="Buscar do Dados" [disabled]="disableButton">
                        <nz-icon nzType="rollback"></nz-icon>
                    </button>
                    <button nz-button nzType="text" nzSize="small" *ngIf="toolTipText!=null" [tooltip]="toolTipText">
                        <nz-icon nzType="question-circle"></nz-icon>
                    </button>
                    <button tabindex="-1" nz-button nzType="text" nzSize="small" aria-label="Pesquisar" (click)="openSearchForm()" [disabled]="disableButton">
                        <nz-icon nzType="search"></nz-icon>
                    </button>
                    <form-field-properties [information]="config" [entityDesc]="entityDesc" [entityName]="entityName" *ngIf="canConfig" [row]="row"></form-field-properties>
                </span>
            </ng-template>
        </div>
    </div>
    <div class="data-object-item">
        <ngx-spinner class="inputspinner" bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="config.COLUMNNAME">
        </ngx-spinner>
        <div class="tem-field" [formGroup]="group">
            <label class="tem-field-label">&nbsp;</label>
            <input nz-input [formControlName]="configRef.COLUMNNAME" [id]="configRef.IDCOLUMN" [required]="config.ISIDENTITY ==1? false : config.ISREQUIRED == 1" #inpRef>
        </div>
    </div>

</div>
